export default "__VITE_ASSET____KpJHZv__"